import useEventCallback from '@unifyapps/hooks/useEventCallback';
import { LOCALE_SEARCH_PARAMS_KEY } from '@unifyapps/network/auth/const';
import { useEffect } from 'react';
import { useGlobalAppStateStore } from '../../../../../stores/app/GlobalAppStateStore';
import { InterfaceModes } from '../../../../../stores/InterfaceStore';
import InterfaceHelper from '../../../../../stores/InterfaceStore/helper/InterfaceHelper';
import { useIsPublicPageInPrivateApp } from '../../../../useIsPublicPageInPrivateApp';
import { useRouter } from '../../../../useRouter';

export function useUpdateLocaleForPublicInterface() {
  const router = useRouter();
  const pathname = router.pathname;
  const searchParams = router.searchParams;

  const currentLocale = useGlobalAppStateStore().hooks.useUserContext().locale;
  const interfaceRecord = useGlobalAppStateStore().hooks.record.useDetails();
  const mode = useGlobalAppStateStore().hooks.useMode();
  const isPublicInterface = InterfaceHelper.isPublicInterface(interfaceRecord);
  const isPublicPageInPrivateApp = useIsPublicPageInPrivateApp();

  const localeInSearchParams = searchParams.get(LOCALE_SEARCH_PARAMS_KEY);

  const allowedLocale = InterfaceHelper.getAllLocalesSet(interfaceRecord);

  useEffect(() => {
    if (
      (isPublicInterface || isPublicPageInPrivateApp || mode === InterfaceModes.PREVIEW) &&
      localeInSearchParams &&
      currentLocale &&
      currentLocale !== localeInSearchParams &&
      allowedLocale.has(localeInSearchParams)
    ) {
      window.location.reload();
    }
  }, [
    currentLocale,
    isPublicInterface,
    mode,
    allowedLocale,
    localeInSearchParams,
    isPublicPageInPrivateApp,
  ]);

  const updateLocaleForPublicInterface = useEventCallback((locale: string) => {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set(LOCALE_SEARCH_PARAMS_KEY, locale);
    const newUrl = `${pathname}?${newSearchParams.toString()}`;
    router.replace(newUrl, true);
    return Promise.resolve();
  });

  return { updateLocaleForPublicInterface };
}
